import * as React from 'react'
import Box from '@mui/material/Box'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import TagIcon from '@mui/icons-material/Tag'
import EventIcon from '@mui/icons-material/Event'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'

import { DialogContext } from '../context/DialogContext.js'

export default function AddButtonLanguage() {
  const { dialogStates, openDialog, closeDialog } = React.useContext(DialogContext)

  const actions = [
    // { icon: <QuestionAnswerIcon />, name: 'Conversation', onClick: () => openDialog('dialogAddConversation') },
    // { icon: <MessageIcon />, name: 'Monologue' },
    // Sentence, Translate to all and Sentences (Bulk) now live on the green
    // Learn dial (HallucinationButton). Meeting Documents is on both.
    { icon: <QuestionAnswerIcon />, name: 'Inspiration', onClick: () => openDialog('dialogAddInspiration') },
    { icon: <TagIcon />, name: 'Consumption', onClick: () => openDialog('dialogAddConsumption') },
    { icon: <EventIcon />, name: 'Meeting Documents', onClick: () => openDialog('dialogAddMeetingDocument') },
    { icon: <SelfImprovementIcon />, name: 'Journal Entry', onClick: () => openDialog('dialogAddJournal') }
    // { icon: <AbcIcon />, name: 'Word', onClick: () => openDialog('dialogAddWord') }
  ]

  return (
    <SpeedDial direction="up" ariaLabel="SpeedDialLanguage" icon={<SpeedDialIcon />}>
      {actions.map((action) => (
        <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
      ))}
    </SpeedDial>
  )
}
